module.exports = "/pages/business/hotelslabo/thanks_bg.png";